module.exports = __webpack_public_path__ + "static/media/nd.4fed020e.svg";